import { combineReducers } from "redux";
import Admin from "./Admin";
import Auth from "./Auth";
import Global from "./Global";
import Role from "./Role";
import Project from "./Project";
import Task from "./Task";
import Phase from "./Phase";
import Dashboard from "./Dashboard";
import Schedule from "./Schedule";
import Document from "./Document";
import MyTask from "./MyTask";
import Meeting from "./Meeting";
import Performance from "./Performance";
import Holiday from "./Holiday";
// 新模組（設計稿新增的 11 個頁面）
import Approval from "./Approval";
import Board from "./Board";
import Report from "./Report";
import Timesheet from "./Timesheet";
import Audit from "./Audit";
import Automation from "./Automation";
import Setting from "./Setting";

export default combineReducers({
  Admin,
  Auth,
  Global,
  Role,
  Project,
  Task,
  Phase,
  Dashboard,
  Schedule,
  Document,
  MyTask,
  Meeting,
  Performance,
  Holiday,
  Approval,
  Board,
  Report,
  Timesheet,
  Audit,
  Automation,
  Setting,
});
